import { Component, OnInit, Input } from '@angular/core';
import { SlideshowImage } from 'src/app/components/slideshow-image.component';

@Component({
  selector: 'slideshow',
  template: `
  <div id="slideshow" [style.min-height.rem]="height" [style.max-height.rem]="height" >
    <slideshow-image *ngFor="let image of slideshowImages" [image]="image" [max-height]="height" (done)="nextImage($event)"></slideshow-image>
  </div>`,
  styles: [
    "#slideshow { margin: 0 auto; position: relative; width: 100%; display: block; }"
  ]
})

export class SlideshowComponent implements OnInit {

  @Input("imageUrls") imageUrls: string[];
  @Input("interval") interval: number = 8000;
  @Input("height") height: number = 12;

  private slideshowImages: SlideshowImage[];
  private index = 0;
  private get length(): number {
    return this.imageUrls.length;
  }

  constructor() { }

  ngOnInit(): void {
    this.slideshowImages = [];
    this.imageUrls.forEach(url => this.slideshowImages.push(new SlideshowImage(url, "hidden")));
    this.slideshowImages[0].state = "visible";
  }

  nextImage(image: SlideshowImage): void {
    if (image.state === "visible") {
      setTimeout(() => {
        this.slideshowImages[this.index].state = "hidden";
        this.index = ++this.index % this.length;
        this.slideshowImages[this.index].state = "visible";
      }, this.interval);
    }
  }
}